// extracted by mini-css-extract-plugin
export default {"HeroContent":"KkKMKbbClH","HeroContent_wrapper":"lJm1pnWlFM","HeroContent_inner":"EQYiwpNnBR"};